<template>
  <div class="baseData">
    <div
      class="base-data-item base-data-item-greenbg"
      v-for="(item, index) in baseData"
      :key="index"
    >
      <div class="title">{{ item.title }}</div>
      <div class="item">{{ item.price }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bondData',
  props: {
    hadRechargeAmount: {
      type: String,
      default: ''
    },
    awaitEarnestMoney: {
      type: String,
      default: ''
    },
    activeEarnestMoney: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      baseData: [
        {
          title: '已充值金额',
          price: '888.88'
        },
        {
          title: '冻结金额',
          price: '888.88'
        },
        {
          title: '可用金额',
          price: '888.88'
        }
      ]
    }
  },
  watch: {
    hadRechargeAmount (val, vall) {
      this.baseData[0].price = val
    },
    awaitEarnestMoney (val, vall) {
      this.baseData[1].price = val
    },
    activeEarnestMoney (val, vall) {
      this.baseData[2].price = val
    },
  },
  mounted () {

  },
  created () {
    this.baseData[0].price = this.hadRechargeAmount
    this.baseData[1].price = this.awaitEarnestMoney
    this.baseData[2].price = this.activeEarnestMoney
  },
  methods: {

  }
}
</script>
<style scoped lang="scss">
.baseData {
  display: flex;
  padding-bottom: 20px;
  justify-content: space-between;
  width: 70%;
}
.title {
  font-size: 16px;
  font-weight: bold;
}
.item {
  font-size: 36px;
  font-weight: bold;
}
.base-data-item {
  width: 30%;
  height: 100px;
  border-radius: 12px;
  margin-right: 16px;
  padding: 16px 20px;
  box-shadow: 1px 2px 10px #e1e1e1;
  color: #333333;
  transition: all 0.5s ease-in;
  &:last-child {
    margin-right: 0;
  }

  .title {
    margin-bottom: 20px;
    label {
      font-size: 16px;
      font-weight: bold;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      float: right;
    }
  }
}

.base-data-item-redbg {
  background: linear-gradient(
    90deg,
    rgba(243, 63, 63, 0) 0%,
    rgba(243, 63, 63, 0.1) 150%
  );
}

.base-data-item-greenbg {
  background: linear-gradient(
    88deg,
    rgba(17, 170, 97, 0) 0%,
    rgba(18, 171, 98, 0.1) 150%
  );
}
</style>
